import React, { Component } from 'react';
import { BasicSetup } from 'Components/basicsetup/BasicSetup';

class GradeSetup extends Component {
  render() {
    return (
      <BasicSetup
        resourcename="grade"
        humanname="Grade"
        canEditId={true}
        useQueryString={true}
        sortById={true}
        {...this.props}
      />
    );
  }
}

export { GradeSetup };



// WEBPACK FOOTER //
// ./src/pages/gradesetup/GradeSetup.js